export default function BrandLogo({ collapsed = false, size = "md" }) {
  const sizes = { sm: 32, md: 40, lg: 56 };
  const px = sizes[size] || sizes.md;

  const mark = (
    <svg width={px} height={px} viewBox="0 0 48 48" fill="none" aria-hidden="true" className="shrink-0">
      <circle cx="24" cy="24" r="20" stroke="#00ADEF" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray="100 26" transform="rotate(-90 24 24)" />
      <circle cx="24" cy="15" r="6" fill="#1D2B53" />
      <path d="M14 38c2.2-6.2 7-10 10-10s7.8 3.8 10 10" fill="#1D2B53" />
      <path d="M22 28h4v8h-4z" fill="#ffffff" />
      <path d="M21 30h6v2h-6z" fill="#ffffff" />
    </svg>
  );

  if (collapsed) {
    return <div className="flex shrink-0 items-center justify-center">{mark}</div>;
  }

  return (
    <div className="flex min-w-0 items-center gap-3">
      {mark}
      <div className="min-w-0 leading-tight">
        <div className="truncate text-base font-extrabold tracking-tight">
          <span className="text-[var(--brand-cyan)]">SHAQO</span>{" "}
          <span className="brand-logo-hage text-white">HAGE</span>
        </div>
        <p className="truncate text-[0.625rem] font-semibold uppercase tracking-[0.18em] text-nexus-text-secondary">
          Multi-Service
        </p>
      </div>
    </div>
  );
}
